export const orderStatusList = [
    "提交订单",
    "审核订单",
    "确认订单",
    "等待发货",
    "已发货",
    "已完成",
    "订单已取消",
]
export const goodsStatusList = [
    '有货',
    '缺货',
    '待确认',
    '已发货',
    '验收完成'
]